import React from 'react';
import Search from '../components/Search';

const SearchResult = ({
  user,
  fetchBooks,
  fetchUserData,
  showNotification,
  updateCurrentlyReading,
}) => {
  return (
    <div className="container">
      {user && (
        <Search
          user={user}
          fetchBooks={fetchBooks}
          fetchUserData={fetchUserData}
          showNotification={showNotification}
          updateCurrentlyReading={updateCurrentlyReading}
        />
      )}
    </div>
  );
};

export default SearchResult;
